/* GET NAILS | Explore the Category. Finite, accessible horizontal carousel. */
(() => {
  const SELECTOR = '[data-gn-explore-category]';

  function setup(root) {
    if (root.dataset.gnExploreReady === 'true') return;
    const viewport = root.querySelector('[data-gn-explore-viewport]');
    const prev = root.querySelector('[data-gn-explore-prev]');
    const next = root.querySelector('[data-gn-explore-next]');
    if (!viewport || !prev || !next) return;
    root.dataset.gnExploreReady = 'true';

    const updateControls = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll - 2;
    };

    const slide = (direction) => {
      const card = viewport.querySelector('.gn-explore-category__item');
      if (!card) return;
      const styles = window.getComputedStyle(viewport.querySelector('.gn-explore-category__track'));
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = (card.getBoundingClientRect().width + gap) * (window.innerWidth < 768 ? 2 : 1);
      viewport.scrollBy({ left: direction * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => slide(-1));
    next.addEventListener('click', () => slide(1));
    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  const init = (scope = document) => {
    if (scope.matches && scope.matches(SELECTOR)) setup(scope);
    scope.querySelectorAll(SELECTOR).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
